import { BaseContainerModel } from '../base-container.model';
import { GenericDocContainerModel } from './generic-doc.model';

export class GenericDocWrapperContainerModel extends BaseContainerModel {
  docType = '';
  operation = 'NA';
  genericDocumentContainer: GenericDocContainerModel = new GenericDocContainerModel();
}
